export  function getOtColors (type) {
  switch (type) {
    case 'afterWork':
      return 'purple'
    case 'night':
      return 'orange'
    case 'restDay':
      return 'blue'
    case 'hollyDay':
      return 'teal'
  }
}
